import React from 'react';
import Section from '../../components/sections/Section';
import MargritBecomesTriff from '../../assets/images/margrit-becomes-triff.png';
import { BERRY } from '../../settings/colors';
import { ScrollView, View } from 'react-native';
import Header from '../../components/Header/Header.web';
import Footer from '../../components/footer/Footer';
import { useHistory } from 'react-router-dom';
import { Button } from '../../components';

function Margrit() {
  const history = useHistory();
  return (
    <ScrollView>
      <Header />
      <View style={{ backgroundColor: BERRY }}>
        <Section style={{ maxWidth: 600, alignItems: 'flex-start' }}>
          <img
            src={MargritBecomesTriff}
            alt={'Margrit heisst neu Triff'}
            width="100%"
            height="100%"
          />
          <p style={{ color: 'white' }}>
            Vor drei Jahren haben wir Margrit lanciert, um Menschen bei
            hausgemachtem Essen zusammen an einen Tisch zu bringen. Mit Erfolg:
            Seither fanden quer durch die Deutschschweiz Hunderte von Essen und
            Tausende von Begegnungen statt.
          </p>
          <p style={{ color: 'white' }}>
            Je länger wir unsere Webseite betrieben, desto klarer wurden zwei
            Dinge. Erstens: Diese Idee gehört in die Hosentasche, sprich: als
            App aufs Smartphone. Und zweitens: Hausgemachtes Essen ist wichtig.
            Aber noch wichtiger sind die Menschen, die man dabei trifft.
          </p>
          <p style={{ color: 'white' }}>
            Ab heute bringen wir deshalb Menschen nicht mehr nur zum Essen
            zusammen, sondern zu allen Arten von Aktivitäten. Freunde genauso
            wie Leute, die sich noch nicht kennen. Und zwar als App mit dem
            Namen Triff.
          </p>
          <p style={{ color: 'white' }}>
            Alles, was du bei Margrit tun konntest, kannst du bei Triff auch tun
            – und noch viel mehr. Eine Geburtstagsfeier mit Freunden, eine
            Wanderung mit neuen Bekanntschaften, ein Fest mit Nachbarn: Was
            immer du vorhast, mit Triff organisierst du es. So einfach wie nie
            zuvor.
          </p>
          <p style={{ color: 'white' }}>
            Auch wenn sich damit einiges ändert, etwas bleibt gleich: Die
            Menschen dahinter. Wir Gründer von Margrit sind auch die Macher von
            Triff. Und wir freuen uns, dass du mittriffst.
          </p>
          <p style={{ color: 'white' }}>
            Tobias und Stefan Ganz,
            <br />
            Gründer und Geschäftsführer
            <br />
          </p>
          <p style={{ color: 'white' }}>Zürich, Februar 2019</p>
          <Button
            backgroundColor="white"
            color={BERRY}
            text="Entdecke Triff"
            action={() => history.push('/')}
          />
        </Section>
      </View>
      <Footer />
    </ScrollView>
  );
}

export default Margrit;
